type LiveRequestExecutor = (resolve: (value?: unknown) => void) => void

let requests: LiveRequestExecutor[] = []
let requestBusy = false
let requestUpdateInterval: number | null = null

const request = () => {
  if (requestBusy) {
    return
  }
  const nextRequest = requests.shift() // 先頭
  if (nextRequest) {
    // 完了していれば次のリクエストを処理
    requestBusy = true
    setTimeout(() => {
      new Promise(nextRequest).then(() => {
        requestBusy = false
        request()
      })
    }, requestUpdateInterval ?? 0)
  }
}

export default {
  /**
   * ライブ映像取得と表示
   * @param updateInterval 映像の描画間隔
   */
  requestNext: (updateInterval = 200) => {
    requestUpdateInterval = updateInterval
    request()
  },
  /**
   * リクエストの追加
   * @param func ライブ画像取得Que
   */
  addRequest(func: LiveRequestExecutor) {
    requests.push(func)
  },
  /**
   * リクエストのリセット
   */
  resetRequest() {
    requests = []
    requestBusy = false
  },
}
